import ShopNearbySection from "./ShopNearbySection";

export { ShopNearbySection as default };
